export default function EndSlide() {
  return (
    <div className="EndSlide">
      <div>
        
      </div>
    </div>
  )
}